import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EVENT5K } from "@/constants/testIds";

const LOGO = "/images/logo-2026.png";

const NavLink = ({ href, children }) => (
  <a
    href={href}
    className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#A3A3A3] hover:text-[#00A651] transition-colors"
  >
    {children}
  </a>
);

export default function Navbar({ onRegister }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all ${
        scrolled ? "bg-[#0A0A0A]/90 backdrop-blur border-b border-[#27272A]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid={EVENT5K.navBrand} className="flex items-center gap-3">
          <img src={LOGO} alt="Freedom In Me Business Showers" className="h-10 md:h-12 w-auto" />
          <div className="hidden md:block leading-tight">
            <div className="font-display text-[15px] font-bold uppercase tracking-wide text-white">Run to Empower</div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-[#00A651]">Entrepreneurs 5K</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          <NavLink href="#overview">Overview</NavLink>
          <NavLink href="#options">Race Options</NavLink>
          <NavLink href="#pricing">Pricing</NavLink>
          <NavLink href="#vendor">Vendors</NavLink>
          <NavLink href="#sponsor">Sponsors</NavLink>
          <NavLink href="#wellness">Wellness</NavLink>
          <NavLink href="#volunteer">Volunteer</NavLink>
          <NavLink href="#faq">FAQ</NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/admin"
            data-testid={EVENT5K.navAdminLink}
            className="hidden md:inline-block text-[11px] uppercase tracking-[0.2em] text-[#71717A] hover:text-white transition-colors"
          >
            Admin
          </Link>
          <button
            data-testid={EVENT5K.navRegister}
            onClick={onRegister}
            className="bg-[#00A651] hover:bg-[#1FBF3E] text-black font-bold uppercase tracking-widest text-xs md:text-sm px-4 md:px-6 py-2.5 md:py-3 transition-all hover:-translate-y-0.5"
          >
            Register
          </button>
        </div>
      </div>
    </header>
  );
}
